/** Auth API helpers */
import { getApiUrl } from "@/lib/api-config";

export interface LoginResponse {
  success: boolean;
  message: string;
  data?: {
    access_token: string;
    token_type: string;
    expires_in: number;
  };
}

export interface LoginError {
  success: false;
  message: string;
  errors?: Record<string, string[]>;
}

export interface SignupSendOtpPayload {
  name: string;
  mobile: string;
  email: string;
  address: string;
  dob: string;
  gender: string;
}

export interface SignupVerifyResponse {
  success: boolean;
  message: string;
  data?: {
    access_token: string;
    token_type: string;
    expires_in: number;
    user?: unknown;
  };
}

/** Send OTP for signup. POST /api/v1/auth/signup/send-otp */
export async function signupSendOtp(
  payload: SignupSendOtpPayload
): Promise<{ success: boolean; message: string }> {
  const res = await fetch(getApiUrl("/api/v1/auth/signup/send-otp"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const json = await res.json();

  if (!res.ok) {
    throw { ...json, status: res.status };
  }

  return json as { success: boolean; message: string };
}

/** Verify OTP and complete signup. POST /api/v1/auth/signup/verify-otp */
export async function signupVerifyOtp(
  mobile: string,
  otp: string
): Promise<SignupVerifyResponse> {
  const res = await fetch(getApiUrl("/api/v1/auth/signup/verify-otp"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ mobile, otp }),
  });
  const json = await res.json();

  if (!res.ok) {
    throw { ...json, status: res.status };
  }

  return json as SignupVerifyResponse;
}

/** Send OTP to mobile. POST /api/v1/auth/otp/send */
export async function sendOtp(mobile: string): Promise<{ success: boolean; message: string }> {
  const res = await fetch(getApiUrl("/api/v1/auth/otp/send"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ mobile }),
  });
  const json = await res.json();

  if (!res.ok) {
    throw { ...json, status: res.status };
  }

  return json as { success: boolean; message: string };
}

/** Verify OTP and login. POST /api/v1/auth/otp/verify */
export async function verifyOtp(mobile: string, otp: string): Promise<LoginResponse> {
  const res = await fetch(getApiUrl("/api/v1/auth/otp/verify"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ mobile, otp }),
  });
  const json = await res.json();

  if (!res.ok) {
    throw { ...json, status: res.status };
  }

  return json as LoginResponse;
}
